export const STAR = "M12 0l2.6 9.4L24 12l-9.4 2.6L12 24l-2.6-9.4L0 12l9.4-2.6z";

const GLYPHS = ["♈", "♉", "♊", "♋", "♌", "♍", "♎", "♏", "♐", "♑", "♒", "♓"].map((g) => g + "\uFE0E");

export const ZodiacWheel = ({ className = "" }) => (
  <svg viewBox="0 0 400 400" className={className} aria-hidden="true">
    <defs>
      <radialGradient id="zw-glow" cx="50%" cy="50%" r="50%">
        <stop offset="0%" stopColor="#D4AF37" stopOpacity="0.22" />
        <stop offset="60%" stopColor="#4C1D95" stopOpacity="0.12" />
        <stop offset="100%" stopColor="#07040D" stopOpacity="0" />
      </radialGradient>
    </defs>
    <circle cx="200" cy="200" r="200" fill="url(#zw-glow)" />
    <g className="spin-slow">
      <circle cx="200" cy="200" r="188" fill="none" stroke="#D4AF37" strokeOpacity="0.5" strokeWidth="0.8" />
      <circle cx="200" cy="200" r="150" fill="none" stroke="#D4AF37" strokeOpacity="0.7" strokeWidth="0.8" />
      {Array.from({ length: 72 }).map((_, i) => (
        <line key={i} x1="200" y1="12" x2="200" y2={i % 6 === 0 ? 30 : 20} stroke="#D4AF37" strokeOpacity="0.6" strokeWidth="0.7" transform={`rotate(${i * 5} 200 200)`} />
      ))}
      {GLYPHS.map((g, i) => {
        const a = ((i * 30 + 15 - 90) * Math.PI) / 180;
        return (
          <text key={i} x={200 + 169 * Math.cos(a)} y={200 + 169 * Math.sin(a)} textAnchor="middle" dominantBaseline="central"
            fill="#F3E5AB" fontSize="18" fontFamily="Georgia, 'Segoe UI Symbol', serif">{g}</text>
        );
      })}
      {Array.from({ length: 12 }).map((_, i) => (
        <line key={`d${i}`} x1="200" y1="50" x2="200" y2="12" stroke="#D4AF37" strokeOpacity="0.35" strokeWidth="0.6" transform={`rotate(${i * 30} 200 200)`} />
      ))}
    </g>
    <g className="spin-rev">
      <circle cx="200" cy="200" r="112" fill="none" stroke="#D4AF37" strokeOpacity="0.4" strokeDasharray="2 6" />
      <polygon points="200,92 293,254 107,254" fill="none" stroke="#D4AF37" strokeOpacity="0.45" strokeWidth="0.8" />
      <polygon points="200,308 107,146 293,146" fill="none" stroke="#D4AF37" strokeOpacity="0.45" strokeWidth="0.8" />
    </g>
    <circle cx="200" cy="200" r="58" fill="#07040D" stroke="#D4AF37" strokeOpacity="0.8" />
    <path d="M214 160a42 42 0 1 0 0 80a33 33 0 1 1 0-80z" fill="#D4AF37" opacity="0.95" />
    <g transform="translate(206 176) scale(0.9)"><path d={STAR} fill="#F3E5AB" /></g>
  </svg>
);
